var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"news"},[_vm._t("header"),_c('div',{staticClass:"news__grid"},_vm._l((_vm.videoLinks),function(link,i){return _c('iframe',{key:i,staticClass:"news__grid-item",attrs:{"src":link}})}),0)],2)}
var staticRenderFns = []

export { render, staticRenderFns }